import { render, staticRenderFns } from "./game-play.vue?vue&type=template&id=05bf5c3a"
import script from "./game-play.vue?vue&type=script&lang=js"
export * from "./game-play.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports